import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    Admin_Parivartan_Create_Regions,
  Admin_Parivartan_Get_States,
  Admin_Region_Name,
} from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const AddNewRegionModalComponent = ({ open, onClose, onRefresh }) => {
  const [form, setForm] = useState({ RegionName: "", StateName: "" });

  const [stateList, setStateList] = useState([]);

  const getAllStates = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_States}`);
      setStateList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, [open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
        StateId: form.StateName,
        RegionName: form.RegionName,
      };
  
      try {
        const res = await axios.post(Admin_Parivartan_Create_Regions, payload);
        console.log("Response:", res);
        if (res.data.success) {
          toast.success("Region Created Successfully.");
          onClose();
          onRefresh();
          handleReset();
        } else{
          toast.error(res.data.message || 'Failed to create region');
        }
      } catch (err) {
        const message =
          err?.response?.data?.message || err?.message || 'Something went wrong';
        toast.error(message);
      }
  };

  const handleReset = () => {
    setForm({ RegionName: "", StateName: "" });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Region
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              labelId="region-label"
              label="Region Name"
              value={form.RegionId}
              onChange={(e) => handleChange("RegionName", e.target.value)}
              size="small"
            />

            <TextField
              labelId="state-label"
              label="State Name"
              value={form.StateName}
              onChange={(e) => handleChange("StateName", e.target.value)}
              size="small"
              select
            >
              <MenuItem value="">
                <em>Select State</em>
              </MenuItem>
              {stateList.map((st) => (
                <MenuItem key={st.StateId} value={st.StateId}>
                  {st.StateName}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddNewRegionModalComponent;
